import { ReactElement, ReactNode } from 'react'
import clsx from 'clsx'

import { Button } from '../../buttons/Button'

type ConfirmationProps = {
  icon: ReactElement
  title: string
  subtitle: string
  notice?: ReactNode
  className?: string
  prefixLinkLabel?: string
  linkLabel?: string
  onLinkClick?: () => void
  submitLabel?: string
  submitIcon?: ReactNode
  onSubmit?: () => void
}

export const Confirmation = ({
  icon,
  title,
  subtitle,
  notice,
  prefixLinkLabel,
  linkLabel,
  onLinkClick,
  submitLabel,
  submitIcon,
  onSubmit,
  className,
}: ConfirmationProps) => {
  return (
    <div className={clsx('fly-form', 'fly-confirmation', className)}>
      <div className="fly-confirmation-icon">{icon}</div>

      <h1 className="display fly-confirmation-title">{title}</h1>
      <p className="fly-confirmation-subtitle">{subtitle}</p>

      {notice && <div className="fly-confirmation-data">{notice}</div>}

      <p className="fly-confirmation-note">
        {prefixLinkLabel ? `${prefixLinkLabel} ` : null}
        {linkLabel && onLinkClick && (
          <Button
            className="fly-confirmation-link"
            variant="ghost"
            size="sm"
            label={linkLabel}
            onClick={onLinkClick}
          />
        )}
      </p>

      {submitLabel && (
        <Button
          className="fly-confirmation-button"
          variant="dark"
          size="lg"
          block
          label={submitLabel}
          icon={submitIcon}
          iconPosition="right"
          onClick={onSubmit}
        />
      )}
    </div>
  )
}
